import { Attribute } from 'models'
import { PaginationProps, SortDirection } from 'utilities'

export type SkuRequestDTO = {
  attributes: Attribute[],
  maxPrice: number
  maxQuantity: number
  maxRevenue: number
  maxSold: number
  minPrice: number
  minQuantity: number
  minRevenue: number
  minSold: number
  sku: string
  status: string
}

export type AttributeMap = Map<string, Map<number, Attribute>>

export enum SkuTableSortProps {
  SKU = 'name',
  PRICE = 'price',
  STOCK = 'stock'
  // SOLD_COUNT = 'soldCount',
  // REVENUE = 'total',
}

export type SkuTablePaginationProps = PaginationProps<SkuTableSortProps>

export const initialSkuTablePaginationProps: SkuTablePaginationProps = {
  page: 0,
  size: 15,
  sortProp: SkuTableSortProps.SKU,
  sortDirection: SortDirection.DESC,
  totalElements: 0,
  totalPages: 0
}

export const initialSkuSearchProps: SkuRequestDTO = {
  attributes: null,
  maxPrice: null,
  maxQuantity: null,
  maxRevenue: null,
  maxSold: null,
  minPrice: null,
  minQuantity: null,
  minRevenue: null,
  minSold: null,
  sku: '',
  status: ''
}
